import React from "react";


import { useHttp } from "../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import useLocalStorage from "use-local-storage";
import LoadingCenter from "../components/LoadingCenter";
import { CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";

const Conditionals = () => {
  const request = useHttp();
  const { data, isLoading } = useQuery({ queryKey: ["conditional"], queryFn: () => request({ url: "/users/conditional", method: "GET" }) });

  const [theme] = useLocalStorage("theme");

  return (
    <div className="d-flex flex-column">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Clientes em condicional</span>
      </div>

      <div className="dashboard__container">
        {isLoading && <LoadingCenter />}

        {!isLoading && (
          <CTable color={theme} borderless hover>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell scope="col" className="u-text-center">Nome do cliente</CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">Vendedor</CTableHeaderCell>
                <CTableHeaderCell scope="col" className="u-text-center">Data criação</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {data?.data.map(user => {
                return (
                  <CTableRow>
                    <CTableDataCell className="u-text-center">{user.name}</CTableDataCell>
                    <CTableDataCell className="u-text-center">{user.name_admin}</CTableDataCell>
                    <CTableDataCell className="u-text-center">{user.start_date_condition}</CTableDataCell>
                  </CTableRow>
                );
              })}
            </CTableBody>
          </CTable>
        )}
      </div>
    </div>
  );
};

export default Conditionals;